<template>
  <VDialog v-model="dialog" width="400">
    <VCard>
      <VCardTitle>{{ $t("addWithFile") }}</VCardTitle>
      <VCardText>
        <ValidationObserver v-slot="{ handleSubmit }" ref="formObs">
          <form @submit.prevent="handleSubmit(sendExcelFile)">
            <div class="d-flex justify-space-between align-center">
              <VSwitch
                hide-details
                :label="$t('used')"
                v-model="carriage.used"
              ></VSwitch>
              <VSwitch
                hide-details
                class=""
                v-model="carriage.full"
                :disabled="carriage.selectedCells[0].full"
                true-value="false"
                false-value="true"
                :label="$t('hasPlace')"
              ></VSwitch>
            </div>
            <ValidationProvider
              tag="div"
              class="py-2 mt-2"
              :name="$t('file')"
              rules="required"
              v-slot="{ errors }"
            >
              <VFileInput
                v-model="carriage.file"
                :error-messages="errors[0]"
                :label="$t('attachFile') + '*'"
              ></VFileInput>
            </ValidationProvider>
            <div class="text-right">
              <VBtn type="submit" color="primary">{{ $t("update") }}</VBtn>
            </div>
          </form>
        </ValidationObserver>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
const CARRIAGE = {
  file: null,
  warehouseId: null,
  selectedCells: null,
  used: false,
  full: false,
};
export default {
  name: "warehouse-file-dialog",
  data() {
    return {
      dialog: false,
      carriage: {
        ...CARRIAGE,
      },
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.file = null;
      }
    },
  },
  methods: {
    async sendExcelFile() {
      try {
        this.showLoading();
        const formData = new FormData();
        formData.append(
          "carriages[0].carriageId",
          this.carriage.selectedCells[0].id
        );
        formData.append("carriages[0].full", this.carriage.full);
        formData.append("file", this.carriage.file);
        formData.append("used", this.carriage.used);
        formData.append("warehouseId", this.carriage.warehouseId);
        await this.$http.post("product-item/import-excel", formData);
        this.clear();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    clear() {
      this.$refs.formObs.reset();
      this.carriage = { ...CARRIAGE };
      this.close();
    },
    open(id, selectedCells) {
      this.carriage.warehouseId = id;
      this.carriage.selectedCells = selectedCells;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
